import React from 'react'
import { Field } from 'react-final-form'

import { fieldError } from '../utils/fieldError'

export const ErrorField = ({ name }) => (
  <Field name={name}>
    {({ meta }) => {
      const error = fieldError(meta)
      return error && <p className="form-message error">{error}</p>
    }}
  </Field>
)
